import { render, staticRenderFns } from "./EventsItem.vue?vue&type=template&id=74b2504f&"
import script from "./EventsItem.vue?vue&type=script&lang=js&"
export * from "./EventsItem.vue?vue&type=script&lang=js&"
import style0 from "./EventsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports